import Yup from '@fourthwall/utils/dist/yup'

export const validationSchema = Yup.object().shape({
  fullName: Yup.string().max(70).noHTML(),
})
